@if (isNewEDPScoreboard) {
    <div class="bases-container">
        <div class="base-runner">
            @if (score && score.currentlyServing === 1) {
                <ms-baseball-scoreboard-base-runner base="{{ homeTeamBase }}"></ms-baseball-scoreboard-base-runner>
            }
        </div>
        <div class="base-runner">
            @if (score && score.currentlyServing === 2) {
                <ms-baseball-scoreboard-base-runner base="{{ awayTeamBase }}"></ms-baseball-scoreboard-base-runner>
            }
        </div>
    </div>
} @else {
    <div class="participant-header-info">
        <div class="baseball-indicator">
            <div class="baseball-team-indicator player1">
                @if (score.currentlyServing === 1) {
                    <vn-icon name="theme-baseball-indicator" class="baseball-indicator-icon" size="9"></vn-icon>
                }
            </div>
            <div class="baseball-team-indicator player2">
                @if (score.currentlyServing === 2) {
                    <vn-icon name="theme-baseball-indicator" class="baseball-indicator-icon" size="9"></vn-icon>
                }
            </div>
        </div>
        <div class="live-participants-container">
            @for (participant of event.participants; let i = $index; track participant) {
                <div class="baseball-participant-info">
                    <ms-scoreboard-participant
                        class="participant-info"
                        [showIndicator]="false"
                        [event]="event"
                        [participant]="event.participants[i]"
                        [isNewEDPScoreboard]="isNewEDPScoreboard">
                    </ms-scoreboard-participant>
                    @if (score && score.currentlyServing === i + 1) {
                        <vn-icon name="theme-baseball-indicator" class="baseball-indicator-icon baseball-indicator-tiny" size="9"></vn-icon>
                    }
                </div>
            }
        </div>
    </div>
}
@if (score) {
    <div class="inning-block" [ngClass]="getInningsClass(innings.length)">
        @if (startingIndex !== 0) {
            <button
                ds-button-icon
                kind="tertiary"
                variant="flat-reduced"
                size="small"
                class="baseball-left-inning-button"
                (click)="scrollLeftDisplayInnings($event)">
                <vn-icon name="sports-baseball-inning-button" class="baseball-left-button" size="8"></vn-icon>
            </button>
        }
        <div>
            <div class="innings innings-header">
                @for (inning of innings | slice: startingIndex : endIndex; track $index) {
                    <div class="set inning-info" [class.highlightedscore]="startingIndex + $index === currentInning">
                        {{ inning }}
                    </div>
                }
            </div>
            @if (!isNewEDPScoreboard) {
                <div class="slidebar"></div>
            }
            <div class="innings">
                @for (inning of innings | slice: startingIndex : endIndex; track $index) {
                    <div class="set" [class.highlighted]="startingIndex + $index === currentInning">
                        {{ getPoints(score.participant1, startingIndex + $index) }}
                    </div>
                }
            </div>
            <div class="innings">
                @for (inning of innings | slice: startingIndex : endIndex; track $index) {
                    <div class="set" [class.highlighted]="startingIndex + $index === currentInning">
                        {{ getPoints(score.participant2, startingIndex + $index) }}
                    </div>
                }
            </div>
        </div>
        @if ((!isMobile && innings.length > endIndex) || (isMobile && endIndex !== innings.length)) {
            <button
                ds-button-icon
                kind="tertiary"
                variant="flat-reduced"
                size="small"
                class="baseball-right-innning-button"
                (click)="scrollRightDisplayInnings($event)">
                <vn-icon name="sports-baseball-inning-button" class="baseball-left-button" size="8"></vn-icon>
            </button>
        }
    </div>
}
@if (isNewEDPScoreboard) {
    <div class="score-container" [ngClass]="{ inactive: eventSuspended }">
        <ms-score-card
            [eventId]="event.id"
            [participant1Score]="score.participant1.points"
            [participant2Score]="score.participant2.points"
            [showSeparator]="!isNewEDPScoreboard">
        </ms-score-card>
    </div>
}
